import { PaperPlaneTiltIcon } from '@phosphor-icons/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useSendAppInvites } from '@/api/clients/send-app-invites'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'

import * as S from './send-app-invite-modal.styled'
import { SendAppInviteModalProps, SendScope } from './send-app-invite-modal.types'

export const SendAppInviteModal = ({
  onClose,
  selectedClients,
  buildingId,
}: SendAppInviteModalProps) => {
  const { t } = useTranslation(['clients', 'common'])
  const [sendScope, setSendScope] = useState<SendScope>('all')
  const { mutateAsync, isPending } = useSendAppInvites()

  const isAll = sendScope === 'all'
  const targets = isAll ? selectedClients : selectedClients.filter((c) => !c.isAppUser)

  const handleSend = async () => {
    await mutateAsync({ buildingId, clientIds: targets.map((c) => Number(c.id)) })
    onClose()
  }

  return (
    <Modal
      title={t('clients:list.actions.sendAppInvite')}
      headerIcon={PaperPlaneTiltIcon}
      size="small"
      footer={
        <>
          <Button use="secondary" onClick={onClose}>
            {t('common:actions.cancel')}
          </Button>
          <Button loading={isPending} disabled={targets.length === 0} onClick={handleSend}>
            {t('clients:sendAppInviteModal.send')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <S.OptionsWrapper>
        <S.OptionRow $isSelected={isAll} onClick={() => setSendScope('all')}>
          <S.RadioDot $isSelected={isAll} />
          <S.OptionLabel>{t('clients:sendAppInviteModal.options.all')}</S.OptionLabel>
        </S.OptionRow>
        <S.OptionRow
          $isSelected={sendScope === 'non-app-users'}
          onClick={() => setSendScope('non-app-users')}
        >
          <S.RadioDot $isSelected={sendScope === 'non-app-users'} />
          <S.OptionLabel>{t('clients:sendAppInviteModal.options.nonAppUsers')}</S.OptionLabel>
        </S.OptionRow>
      </S.OptionsWrapper>
    </Modal>
  )
}
